var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"loading-mask"},[_c('div',{staticClass:"loading-content"},[_c('div',{staticClass:"loading-spinner",style:({ borderTopColor: _vm.color, borderRightColor: _vm.color })}),_c('div',{staticClass:"loading-text",style:({ color: _vm.color })},[_vm._v("加载中...")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }